import localforage from 'localforage';

export const lookupsStore = localforage.createInstance({ name: 'NewCustomerLookups' });
